import { TIMELINE_ITEM_KINDS } from '../services/api/timeline';

export const isPostTimelineItem = (item) => (
    !item?.timelineItemKind || item.timelineItemKind === TIMELINE_ITEM_KINDS.POST
);

export const isScheduledEntityTimelineItem = (item) => (
    !isPostTimelineItem(item) && (item?.objectType === 'EVENT' || item?.objectType === 'SESSION')
);
